var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popular-searches-inline',{staticClass:"popular-searches-multiline",attrs:{"preview-amount":_vm.previewAmount,"max-title-length":_vm.maxTitleLength,"full-type":"none"},on:{"select":(tag) => _vm.$emit('select', tag),"ready":() => _vm.$emit('ready')}})
}
var staticRenderFns = []

export { render, staticRenderFns }